var baseUrl = ""

if(process.env.NODE_ENV === 'production'){
    // 生产环境
    baseUrl = 'https://shoph5.jphl.com'
}else{
    // 开发环境
    baseUrl = 'https://shoph5test.jphl.com'
}

export default baseUrl
